import React, { useEffect, useState } from "react";
import { getToken, isLogin } from "../../Utils/token";
import { isQ2ServiceProvider } from "../../Utils/ServiceProviders/q2";
import { isBannoServiceProvider } from "../../Utils/ServiceProviders/banno";
import { isLuminServiceProvider } from "../../Utils/ServiceProviders/lumin";

const Loader = (props) => {
  const type = isLogin() ? `-post` : "-post";
  const { loaderclass = "" } = props;

  const [token, settoken] = useState();

  useEffect(() => {
    const t = getToken() || null;
    settoken(t);
  }, []);

  if (props.identifier === "0") {
    document.querySelectorAll(".loader-div").forEach((e) => {
      e.classList.remove("show");
    });
  } else {
    document.querySelectorAll(".loader-div").forEach((e) => {
      e.classList.add("show");
    });
  }

  return (
    <>
      {sessionStorage.getItem('tenant') === "mazoolaplus" && (
        <>
          {props.identifier === "0" && (
            <div className={`loader-div hide ${loaderclass}`}>
              <div className={`loader${type}`}>
                <div className="ldio-7cxkyhjer4s">
                  <div></div>
                </div>
              </div>
            </div>
          )}
          {!token && props.identifier === "1" && (
            <div className="loader-div-post hide">
              <div className={`loader${type}`}>
                <div className="ldio-7cxkyhjer4s">
                  <div></div>
                </div>
              </div>
            </div>
          )}
        </>
      )}

      {isQ2ServiceProvider(sessionStorage.getItem('tenant'), false) && (
        <>
          {props.identifier === "0" && (
            <div className={`loader-div q2-loader-div hide ${loaderclass}`}>
              <div className={`loader${type}`}>
                <div class="q2-loading-animation half-circle-spinner" aria-label="Loading"><div class="circle circle-1"></div><div class="circle circle-2"></div></div>
              </div>
            </div>
          )}
          {!token && props.identifier === "1" && (
            <div className="loader-div-post q2-loader-div-post hide">
              <div className={`loader${type}`}>
                <div class="q2-loading-animation half-circle-spinner" aria-label="Loading"><div class="circle circle-1"></div><div class="circle circle-2"></div></div>
              </div>
            </div>
          )}
        </>
      )}

      {isBannoServiceProvider(sessionStorage.getItem('tenant'), false) && (
        <>
          {props.identifier === "0" && (
            <div className={`loader-div banno-loader-div hide ${loaderclass}`}>
              <div className={`loader${type}`}>
                <div className="banno-spinner"></div>
              </div>
            </div>
          )}
          {!token && props.identifier === "1" && (
            <div className="loader-div-post banno-loader-div-post hide">
              <div className={`loader${type}`}>
                <div className="banno-spinner"></div>
              </div>
            </div>
          )}
        </>
      )}

      {isLuminServiceProvider(sessionStorage.getItem('tenant'), false) && (
        <>
          {props.identifier === "0" && (
            <div className={`loader-div lumen-loader-div hide ${loaderclass}`}>
              <div className={`loader${type}`}>
                <div className="lumen-spinner"></div>
              </div>
            </div>
          )}
          {!token && props.identifier === "1" && (
            <div className="loader-div-post lumen-loader-div-post hide">
              <div className={`loader${type}`}>
                <div className="lumen-spinner"></div>
              </div>
            </div>
          )}
        </>
      )}
    </>
  );
};

export default Loader;
